import {apiBase} from '@/api/ApiBase'
import {auth, me} from '@/api'
import {getFromStorage, removeFromStorage, storeToStorage} from '@/store/storage'

const tokenKey = 'token'

export const login = async ({mail, password}) => {
  const result = await auth({mail, password})
  const token = result.data
  if (!token) {
    return false
  }
  storeToStorage(tokenKey, token)
  apiBase.token = token

  return true
}

export const logout = () => {
  removeFromStorage(tokenKey)
  apiBase.token = null
}

export const getToken = () => {
  return getFromStorage(tokenKey, null)
}

export const restoreToken = () => {
  apiBase.token = getFromStorage(tokenKey, null)
}

export const isLogin = async () => {
  const token = getToken()
  if (!token) {
    return false
  }
  try {
    apiBase.token = token
    const result = await me()
    if (result.newToken) {
      apiBase.token = result.newToken
      storeToStorage(tokenKey, token)
    }
  } catch (_) {
    logout()
    return false
  }
  return true
}

export const keepLoginKey = 'stKey_keepLogin'
export const rememberIdKey = 'stKey_rememberId'
export const rememberIdMailKey = 'stKey_rememberId_mail'
export const ifLoginDo = async (callback = () => {}) => {
  if (!getFromStorage(keepLoginKey, false)) {
    return
  }
  if (await isLogin()) {
    callback()
  }
}

